<ngx-select
  [items]="items"  
  [optionValueField]="bindValue"
  [optionTextField]="bindLabel"
  [placeholder]="placeholder"
  [ngModel]="value"
  (ngModelChange)="doSelect($event)"
  (blur)="doBlur()"
  [disabled]="disabled"
  [defaultValue]="selectedValue"
  [noAutoComplete]="items && items.length <= 20"
  [allowClear]="false">
</ngx-select>